module.exports = __webpack_public_path__ + "img/blockquote-right.d321b0e2.svg";